<!-- 这个实现的难点在于，将来启用懒加载的方式的话，需要动态的添加子评论的 e-row 节点 -->
<!-- 第一期的设计实现如下，
     组件：
       1. Comment
       2. Thread
     功能：Comment 中包含两级评论（Thread），即 main thread 和 sub threads，且 sub threads 是一次性全部读入，没有懒加载的行为！
     样式：
       1. 每个 Thread 默认 margin-top 20px
       2. 所有的评论都包裹在 comments 元素中且 margin-bottom 10px
-->
<!-- 一级评论懒加载（设计的目的主要是降低数据库查询的复杂性）
     1. 当有子评论的 root comment 还没有加载子评论的时候，提供加载的入口按钮å
-->
<template>
    <div class="comments">
        <!-- Vue 官方建议维护 id 提升数组元素与 DOM 响应式的性能 https://cn.vuejs.org/v2/guide/list.html#维护状态 -->
        <!-- 指定 id 属性：目的是为了为新添加的 comment 增加 scroll 特效 -->
        <thread v-for="(c, index) in this.comments_" :key="c.id"
                :thread-id=c.id
                :root-id="c.root"
                :username="c.username"
                :content="c.content"
                :likes="c.likes"
                :is-liked="c.is_liked"
                :timestamp="c.create_ts"
                :thread-spacing="index === 0 ? '0px': '20px'"
                v-bind="$attrs">
            <div v-if="hasChild(c)">
                <div v-if="!isLazyLoaded(c)" class="check-reply" align="left" @click="checkReplies(c)">
                    <div class="slash"></div>
                    <div class="desc">查看回复 ({{c.child_comment_count}})</div>
                    <div align="center" style="width:180px; padding-top:10px" v-show="loading"><loading :text="null" :style-object="{fontSize: '22px'}"></loading></div>
                </div>
                <!-- 填充二级评论 slot -->
                <thread
                    v-else
                    v-for="t in c.threads" :key="t.id"
                    :thread-id=t.id
                    :root-id="t.root"
                    :username="t.username"
                    :content="t.content"
                    :likes="t.likes"
                    :is-liked="t.is_liked"
                    :timestamp="t.create_ts"
                    v-bind="$attrs">
                </thread>
            </div>
        </thread>
    </div>
</template>

<script>
    import Thread from './Thread'
    import {CachedApiSecurity} from "../../api-security";
    import {errorMessage, getCachedUser} from "../../utils";
    import {getRootChildComments} from "../../data/comment";
    import assert from 'assert';
    import Vue from "vue";

    export default {
        name: "Comment",
        components: {
            Thread
        },
        props: {
            comments: Array
        },
        data(){
            return {
                comments_: this.comments,  // 响应式的属性最好是定义在 data 中。
                loading: false
            }
        },
        computed: {
            hasComments: function(){
                console.log(`this.comments_.length: ${this.comments_.length}`);
                return this.comments_.length > 0 ? true: false;
            }
        },
        created() {
            this.$EventBus.$on('signout', () => {
                console.log('Comment, caught the signout global event');
            });
        },
        beforeDestroy() {
            // 说是（https://juejin.cn/post/6861572888420581390），在该组件被销毁的时候，需要移除对该事件的监听。
            this.$EventBus.$off('signout', );
        },
        methods: {
            hasChild(rootThread){
                return rootThread.child_comment_count > 0 ? true: false;
            },
            /**
             * 判断当前的 root thread 的子评论是否已经加载。如果该 root comment 没有子评论，那么也同样返回 true
             * @parent {Object} rootThread，main thread
             */
            isLazyLoaded(rootThread){
                // 记住，前端的 comment 中是没有 parent_id 这个字段的，这层关系由面向对象关系即 thread.threads 来维护了。
                // console.log(`Comment, is lazy loaded, root thread: ${JSON.stringify(rootThread)}`);
                // assert(rootThread.parent_id === null, "the root thread's parent id must be null");
                if(rootThread.child_comment_count > 0){
                    // 如果有 child comment，但是 child comments 并没有加载，则返回 false
                    if(rootThread.threads === undefined || rootThread.threads === null || rootThread.threads.length == 0)
                        return false;
                }
                return true;
            },
            /**
             * 查看 root thread 的所有子评论，需要向服务器请求
             * check reply 的场景实际有两个
             *    1. 一是点击"查看回复"
             *    2. 二是点击"回复"并"提交评论"后，如果 root comment has childs，那么需要异步的去服务器获取已经有的 child threads；这部分
             *       逻辑是在 input submit comment 的地方实现的。
             * @param {Object} root, the root thread.
             */
            checkReplies(root){
                console.log(`check replies for main thread: ${root.id}`);
                this.loading = true;
                getRootChildComments(root.id).then(threads => {
                    if(root.threads === undefined || root.threads === null)
                        Vue.set(root, 'threads', new Array()); // 新增属性 threads 并将其纳入响应式管理！
                    for(let t of threads) {
                        root.threads.push(t);
                    }
                }).catch( error => {
                    errorMessage(error.message);
                }).finally( () => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>
    .comments{
        margin-bottom: 10px
    }
    .check-reply{
        display: inline-block;
        cursor: pointer;
        padding-top: 8px;
    }
    .check-reply:hover{
        color: #CB0101;
    }
    .check-reply .slash{
        display: inline-block;
        border-bottom: 1px solid rgba(var(--f52,191,191,191),1);
        height: 0;
        margin-right: 8px;
        vertical-align: middle;
        width: 24px;
    }
    .check-reply .desc{
        display:inline-block;
        font-size:12px
    }
</style>



// WEBPACK FOOTER //
// src/components/comments/Comment.vue